import { Auditable, QueryParams, SortParams } from "..";

export interface FollowUp extends Auditable {
    name: string;
}

export const DefaultFollowUpQueryParams: QueryParams = {
    name: "",
};

export const DefaultFollowUpSortParams: SortParams = {
    orderBy: "name",
    orderDesc: "false",
};
